module.exports = __webpack_public_path__ + "static/media/Barmag FK6 Cutter.21b71fd6.jpg";